import Vue from 'vue';
import Router from 'vue-router';
import Tel from '@/components/header';
import List from '@/components/list';
import Detail from '@/components/detail';
import Opport from '@/components/opportunity';
import Result from '@/components/result';
import NewResult from '@/components/new-result';
import Product from '@/components/Product';
import Productdetail from '@/components/Productdetail';

Vue.use(Router);
const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
        // savedPosition is only available for popstate navigations.
        return savedPosition
    } else {
        const position = {};
        // new navigation.
        // scroll to anchor by returning the selector
        if (to.hash) {
            position.selector = to.hash
        }
        // check if any matched route config has meta that requires scrolling to top
        if (to.matched.some(m => m.meta.scrollToTop)) {
            // cords will be used if no selector is provided,
            // or if the selector didn't match any element.
            position.x = 0;
            position.y = 0
        }
        // if the returned position is falsy or an empty object,
        // will retain current scroll position.
        return position
    }
};
export default new Router({
    mode: 'history',
    scrollBehavior,
    routes: [
        {
            path: '/myy/',
            name: 'Tel',
            component: Tel
        },
        {
            path: '/myy/Product',
            name: 'Product',
            component: Product
        },
        {
            path: '/myy/Productdetail',
            name: 'Productdetail',
            component: Productdetail
        },
        {
            path: '/myy/list/:type?',
            name: 'List',
            component: List
        },
        {
            path: '/myy/detail/:id',
            name: 'Detail',
            component: Detail
        },
        {
            path: '/myy/opport/:activity_id/:channel',
            name: 'Opport',
            component: Opport
        },
        {
            path: '/myy/result/:qr/:bac',
            name: 'result',
            component: NewResult
        },
        {
            path: '*',
            redirect: {
                name: 'Tel'
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js